import styled from 'styled-components';

export const TextWrapper = styled.div<{ withoutBottomMargin: boolean }>`
  ${({ withoutBottomMargin }) =>
    !withoutBottomMargin && 'p { margin-bottom: 10px;}'}
`;
